export default {
      id: "shipment__box-usage",
      viewBox: "0 0 26 19",
      url: __webpack_public_path__ + "img/icons.svg#shipment__box",
      toString: function () {
        return this.url;
      }
    }